const SUBMIT_USER_FORM = "my-account/submit-user-form";
const TOGGLE_FORM_EDIT_MODE = "my-account/toggle-form-edit-mode";
const toggleFormEditMode = (payload) => ({
  type: TOGGLE_FORM_EDIT_MODE,
  payload
});
const submitUserForm = (payload) => ({
  type: SUBMIT_USER_FORM,
  payload
});
export {
  SUBMIT_USER_FORM,
  TOGGLE_FORM_EDIT_MODE,
  submitUserForm,
  toggleFormEditMode
};
//# sourceMappingURL=actions.js.map
